/*
 * Vallenzi Bundle & Save (quantity breaks, free gifts, add-ons)
 * Built by Claude for the CLAUDE theme — Oct 2026.
 * Everything is configured in the theme editor (product page > "Bundle & Save" block).
 */
(function () {
  if (window.customElements.get('sv-bundle')) return;

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var fmt = format || '£{{amount}}';
    function withDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = typeof decimal === 'undefined' ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    var m = fmt.match(placeholder);
    switch (m ? m[1] : 'amount') {
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ''); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': value = withDelimiters(cents, 2, ' ', '.'); break;
      default: value = withDelimiters(cents, 2);
    }
    return fmt.replace(placeholder, value);
  }

  function fill(template, tokens) {
    if (!template) return '';
    return template.replace(/\[(\w+)\]/g, function (all, key) {
      return Object.prototype.hasOwnProperty.call(tokens, key) ? tokens[key] : all;
    });
  }

  /* Countdown (Bundle & Save block > Countdown timer) */
  function startTimer(el) {
    if (el.__svTimer) return;
    var mode = el.dataset.mode || 'daily';
    var now = Date.now();
    var end;
    if (mode === 'date') {
      var raw = (el.dataset.date || '').trim().replace(' ', 'T');
      end = raw ? new Date(raw).getTime() : NaN;
    } else if (mode === 'evergreen') {
      var mins = Math.max(1, parseInt(el.dataset.minutes, 10) || 30);
      var key = 'svTimer:' + (el.dataset.key || location.pathname);
      var saved = 0;
      try { saved = parseInt(localStorage.getItem(key), 10) || 0; } catch (e) {}
      if (!saved || saved < now) {
        saved = now + mins * 60000;
        try { localStorage.setItem(key, String(saved)); } catch (e) {}
      }
      end = saved;
    } else {
      var d = new Date();
      d.setHours(23, 59, 59, 999);
      end = d.getTime();
    }
    if (isNaN(end)) return;
    var q = function (s) { return el.querySelector(s); };
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var tick = function () {
      var left = Math.max(0, end - Date.now());
      if (left <= 0) {
        clearInterval(el.__svTimer);
        var exp = q('[data-sv-timer-expired]');
        if (el.dataset.expired === 'text' && exp) {
          q('[data-sv-timer-boxes]').hidden = true;
          exp.hidden = false;
          el.hidden = false;
        } else {
          el.hidden = true;
        }
        return;
      }
      var s = Math.floor(left / 1000);
      var days = Math.floor(s / 86400);
      var dBox = q('[data-sv-days-box]');
      if (dBox) dBox.hidden = days < 1;
      q('[data-sv-d]').textContent = days;
      q('[data-sv-h]').textContent = pad(Math.floor((s % 86400) / 3600));
      q('[data-sv-m]').textContent = pad(Math.floor((s % 3600) / 60));
      q('[data-sv-s]').textContent = pad(s % 60);
      el.hidden = false;
    };
    tick();
    el.__svTimer = setInterval(tick, 1000);
  }

  class SvBundle extends HTMLElement {
    connectedCallback() {
      var dataEl = this.querySelector('script[data-sv-bundle-data]');
      if (!dataEl) return;
      try {
        this.data = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }
      if (!this.data || !Array.isArray(this.data.tiers) || !this.data.tiers.length || !Array.isArray(this.data.variants) || !this.data.variants.length) { this.hidden = true; return; }
      this.sectionId = this.dataset.section;
      this.form = document.getElementById(this.dataset.formId);
      this.tiers = Array.prototype.slice.call(this.querySelectorAll('[data-sv-tier]'));
      this.errorEl = this.querySelector('[data-sv-error]');
      this.rate = (window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate)) || 1;
      this.unitVariants = [];
      this.customised = false;
      this.currentVariant = this.findVariant(this.getFormVariantId()) || this.data.variants.find(function (v) { return v.available; }) || this.data.variants[0];

      var self = this;
      this.onTierChange = function (e) {
        var input = e.target.closest('input[data-sv-tier-input]');
        if (!input) return;
        self.selectTier(parseInt(input.value, 10));
      };
      this.addEventListener('change', this.onTierChange);
      this.addEventListener('click', function (e) {
        if (e.target.closest('label, input, select, button, a, textarea')) return;
        var tierEl = e.target.closest('[data-sv-tier]');
        if (!tierEl) return;
        var idx = self.tiers.indexOf(tierEl);
        if (idx > -1 && idx !== self.tierIndex) self.selectTier(idx);
      });
      this.addEventListener('change', function (e) {
        if (e.target.matches('select[data-sv-unit-option]')) self.onUnitOptionChange(e.target);
        if (e.target.matches('input[data-sv-addon]')) self.render();
      });

      this.querySelectorAll('[data-sv-timer]').forEach(startTimer);
      this.bindVariantSync();
      this.bindAddToCart();

      var checked = this.querySelector('input[data-sv-tier-input]:checked');
      this.selectTier(checked ? parseInt(checked.value, 10) : 0);
    }

    disconnectedCallback() {
      if (this.clickHandler) document.removeEventListener('click', this.clickHandler, true);
      if (this.submitHandler && this.form) this.form.removeEventListener('submit', this.submitHandler, true);
      if (this.variantObserver) this.variantObserver.disconnect();
    }

    /* ---------- variants ---------- */
    getFormVariantId() {
      if (!this.form) return null;
      var input = this.form.querySelector('[name="id"]');
      return input ? parseInt(input.value, 10) : null;
    }

    findVariant(id) {
      if (!id) return null;
      return this.data.variants.find(function (v) { return v.id === id; }) || null;
    }

    variantByOptions(opts) {
      return this.data.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      }) || null;
    }

    bindVariantSync() {
      var self = this;
      if (!this.form) return;
      var input = this.form.querySelector('[name="id"]');
      if (!input) return;
      var sync = function () {
        var v = self.findVariant(parseInt(input.value, 10));
        if (!v || (self.currentVariant && v.id === self.currentVariant.id)) return;
        self.currentVariant = v;
        if (!self.customised) self.unitVariants = [];
        self.render();
      };
      input.addEventListener('change', sync);
      this.variantObserver = new MutationObserver(sync);
      this.variantObserver.observe(input, { attributes: true, attributeFilter: ['value'] });
      document.addEventListener('change', function (e) {
        if (e.target.closest('variant-radios, variant-selects, .product-form__input')) setTimeout(sync, 50);
      });
    }

    /* ---------- tiers ---------- */
    selectTier(index) {
      this.tierIndex = index;
      this.tiers.forEach(function (el, i) {
        var on = i === index;
        el.classList.toggle('is-selected', on);
        var input = el.querySelector('input[data-sv-tier-input]');
        if (input) input.checked = on;
      });
      this.render();
    }

    tier() {
      return this.data.tiers[this.tierIndex] || this.data.tiers[0];
    }

    unitCount(t) {
      var free = t.gift_mode === 'same' && this.data.eligible ? t.gift_qty : 0;
      return t.qty + free;
    }

    ensureUnits() {
      var t = this.tier();
      var n = this.unitCount(t);
      while (this.unitVariants.length < n) this.unitVariants.push(this.currentVariant);
      this.unitVariants.length = n;
    }

    onUnitOptionChange(select) {
      var unit = parseInt(select.dataset.unit, 10);
      var row = this.querySelectorAll('[data-sv-unit-row="' + unit + '"] select[data-sv-unit-option]');
      var opts = Array.prototype.map.call(row, function (s) { return s.value; });
      var v = this.variantByOptions(opts);
      if (v) {
        this.unitVariants[unit] = v;
        this.customised = true;
      }
      this.render(true);
    }

    /* ---------- pricing ---------- */
    tierNumbers(t, units) {
      var d = this.data;
      var eligible = d.eligible;
      var paidUnits = units.slice(0, t.qty);
      var freeUnits = units.slice(t.qty);
      var paid = 0;
      var compare = 0;
      paidUnits.forEach(function (v) {
        paid += v.price;
        compare += Math.max(v.compare_at_price || 0, v.price);
      });
      var total = paid;
      if (eligible && t.discount_type === 'percentage' && t.discount_value > 0) {
        total = Math.round(paid * (100 - t.discount_value) / 100);
      } else if (eligible && t.discount_type === 'amount' && t.discount_value > 0) {
        total = Math.max(0, paid - Math.round(t.discount_value * 100 * this.rate) * t.qty);
      }
      var giftValue = 0;
      if (eligible && t.gift_mode === 'same') {
        freeUnits.forEach(function (v) { giftValue += Math.max(v.compare_at_price || 0, v.price); });
      } else if (eligible && t.gift_mode === 'product' && t.gift) {
        giftValue = Math.max(t.gift.compare_at_price || 0, t.gift.price) * t.gift_qty;
      }
      if (eligible && t.perks) {
        t.perks.forEach(function (p) { giftValue += Math.max(p.compare_at_price || 0, p.price) * (p.qty || 1); });
      }
      if (!d.compare_from_compare_at) {
        compare = 0;
        paidUnits.forEach(function (v) { compare += v.price; });
      }
      var compareTotal = compare + giftValue;
      var savings = Math.max(0, compareTotal - total);
      var percent = compareTotal > 0 ? Math.round((savings / compareTotal) * 100) : 0;
      return { total: total, compare: compareTotal, savings: savings, percent: percent, unit: t.qty ? Math.round(total / (t.qty + (eligible && t.gift_mode === 'same' ? t.gift_qty : 0))) : total };
    }

    tokens(t, n) {
      var fmt = this.data.money_format;
      var discount = '';
      if (t.discount_type === 'percentage') discount = t.discount_value + '%';
      else if (t.discount_type === 'amount') discount = formatMoney(Math.round(t.discount_value * 100 * this.rate), fmt);
      return {
        quantity: String(t.qty),
        gift_quantity: String(t.gift_qty || 0),
        total_quantity: String(t.qty + (t.gift_mode === 'same' ? t.gift_qty : 0)),
        discount: discount,
        price: formatMoney(n.total, fmt),
        compare_price: formatMoney(n.compare, fmt),
        unit_price: formatMoney(n.unit, fmt),
        price_each: formatMoney(n.unit, fmt),
        savings: this.data.savings_format === 'percent' ? n.percent + '%' : formatMoney(n.savings, fmt),
        amount_saved: formatMoney(n.savings, fmt),
        percent_saved: n.percent + '%'
      };
    }

    /* ---------- render ---------- */
    render(keepPickers) {
      var self = this;
      var d = this.data;
      var fmt = d.money_format;
      this.ensureUnits();

      this.tiers.forEach(function (el, i) {
        var t = d.tiers[i];
        var units = i === self.tierIndex ? self.unitVariants.slice() : [];
        if (i !== self.tierIndex) {
          for (var k = 0; k < self.unitCount(t); k++) units.push(self.currentVariant);
        }
        var n = self.tierNumbers(t, units);
        var tok = self.tokens(t, n);
        var set = function (sel, text) {
          var node = el.querySelector(sel);
          if (node) node.textContent = text;
        };
        set('[data-sv-title]', fill(t.title, tok));
        set('[data-sv-subtitle]', d.eligible ? fill(t.subtitle, tok) : '');
        set('[data-sv-price]', formatMoney(n.total, fmt));
        var cmp = el.querySelector('[data-sv-compare]');
        if (cmp) {
          var showCompare = d.show_compare && n.compare > n.total;
          cmp.textContent = showCompare ? formatMoney(n.compare, fmt) : '';
          cmp.hidden = !showCompare;
        }
        var save = el.querySelector('[data-sv-save]');
        if (save) {
          var showSave = d.show_savings && n.savings > 0;
          save.textContent = showSave ? fill(d.strings.save_label, tok) : '';
          save.hidden = !showSave;
        }
        var unitEl = el.querySelector('[data-sv-unit]');
        if (unitEl) {
          var showUnit = d.show_unit_price && (t.qty > 1 || (t.gift_mode === 'same' && t.gift_qty > 0));
          unitEl.textContent = showUnit ? fill(d.strings.unit_label, tok) : '';
          unitEl.hidden = !showUnit;
        }
        var giftTag = el.querySelector('[data-sv-gift-tag]');
        if (giftTag) giftTag.textContent = fill(giftTag.dataset.template || '', tok);
        if (i === self.tierIndex) self.currentNumbers = n;
      });

      if (!keepPickers) this.renderPickers();
      this.renderAddons();
      this.updateButtonLabel();
      this.toggleExpressButtons();
    }

    toggleExpressButtons() {
      // Express checkout (Shop Pay, Apple Pay…) only buys 1 variant, so hide it while a multi-unit bundle is selected
      if (!this.form) return;
      var hide = this.needsCustomAdd();
      this.form.querySelectorAll('.shopify-payment-button, [data-shopify="payment-button"]').forEach(function (el) {
        el.style.display = hide ? 'none' : '';
      });
    }

    renderPickers() {
      var d = this.data;
      var t = this.tier();
      var host = this.tiers[this.tierIndex] && this.tiers[this.tierIndex].querySelector('[data-sv-pickers]');
      this.querySelectorAll('[data-sv-pickers]').forEach(function (h) { h.innerHTML = ''; });
      if (!host || !d.per_unit_variants || !d.has_variants) return;
      var count = this.unitCount(t);
      if (count < 2 && !d.pickers_on_single) return;
      var frag = document.createDocumentFragment();
      for (var u = 0; u < count; u++) {
        var row = document.createElement('div');
        row.className = 'sv-bundle__unit';
        row.setAttribute('data-sv-unit-row', u);
        var label = document.createElement('span');
        label.className = 'sv-bundle__unit-label';
        var isFree = u >= t.qty;
        label.textContent = isFree ? d.strings.free_short : '#' + (u + 1);
        if (isFree) label.classList.add('is-free');
        row.appendChild(label);
        var v = this.unitVariants[u] || this.currentVariant;
        d.options.forEach(function (opt, oi) {
          var wrap = document.createElement('label');
          wrap.className = 'sv-bundle__select';
          var hidden = document.createElement('span');
          hidden.className = 'visually-hidden';
          hidden.textContent = opt.name + ' ' + (u + 1);
          wrap.appendChild(hidden);
          var sel = document.createElement('select');
          sel.setAttribute('data-sv-unit-option', oi);
          sel.dataset.unit = u;
          opt.values.forEach(function (val) {
            var o = document.createElement('option');
            o.value = val;
            o.textContent = val;
            var probe = v.options.slice();
            probe[oi] = val;
            var pv = d.variants.find(function (x) { return x.options.every(function (y, yi) { return y === probe[yi]; }); });
            if (!pv || !pv.available) {
              o.disabled = !pv;
              if (pv && !pv.available) o.textContent = val + ' — ' + d.strings.sold_out;
            }
            if (v.options[oi] === val) o.selected = true;
            sel.appendChild(o);
          });
          wrap.appendChild(sel);
          row.appendChild(wrap);
        });
        frag.appendChild(row);
      }
      host.appendChild(frag);
    }

    renderAddons() {
      var d = this.data;
      var fmt = d.money_format;
      this.querySelectorAll('[data-sv-addon-row]').forEach(function (row) {
        var a = d.addons[parseInt(row.dataset.svAddonRow, 10)];
        if (!a) return;
        var price = Math.round(a.price * (100 - (d.eligible ? d.addon_discount : 0)) / 100);
        var p = row.querySelector('[data-sv-addon-price]');
        if (p) p.textContent = formatMoney(price, fmt);
        var c = row.querySelector('[data-sv-addon-compare]');
        if (c) {
          var cmpVal = Math.max(a.compare_at_price || 0, a.price);
          c.textContent = cmpVal > price ? formatMoney(cmpVal, fmt) : '';
          c.hidden = !(cmpVal > price);
        }
      });
      if (d.addon_position === 'tier') {
        var host = this.tiers[this.tierIndex] && this.tiers[this.tierIndex].querySelector('[data-sv-addon-host]');
        var box = this.querySelector('[data-sv-addons]');
        if (host && box && box.parentNode !== host) host.appendChild(box);
      }
    }

    selectedAddons() {
      var d = this.data;
      return Array.prototype.slice.call(this.querySelectorAll('input[data-sv-addon]:checked')).map(function (i) {
        return d.addons[parseInt(i.value, 10)];
      }).filter(Boolean);
    }

    updateButtonLabel() {
      if (!this.data.total_on_button || !this.currentNumbers) return;
      var addons = this.selectedAddons();
      var fmt = this.data.money_format;
      var extra = 0;
      var disc = this.data.eligible ? this.data.addon_discount : 0;
      addons.forEach(function (a) { extra += Math.round(a.price * (100 - disc) / 100); });
      var total = formatMoney(this.currentNumbers.total + extra, fmt);
      var buttons = document.querySelectorAll('#ProductSubmitButton-' + this.sectionId + ', [id^="SectionAtcBtn-"]');
      buttons.forEach(function (btn) {
        var span = btn.querySelector('.main-atc__label__text, .sticky-atc__label__text, [class*="label__text"]') || btn.querySelector('span:not([class*="error"]):not(.visually-hidden)') || btn;
        if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
        if (!span.dataset.svBase) span.dataset.svBase = span.textContent.trim();
        span.textContent = span.dataset.svBase + ' · ' + total;
      });
    }

    /* ---------- add to cart ---------- */
    needsCustomAdd() {
      var t = this.tier();
      if (!t) return false;
      if (t.qty > 1) return true;
      if (this.data.eligible && t.gift_mode !== 'none' && t.gift_qty > 0) return true;
      if (this.data.eligible && t.perks && t.perks.length) return true;
      if (this.selectedAddons().length) return true;
      return false;
    }

    bindAddToCart() {
      var self = this;
      var selector = '#ProductSubmitButton-' + this.sectionId + ', [id^="SectionAtcBtn-"]';
      this.clickHandler = function (e) {
        var btn = e.target.closest(selector);
        if (!btn || !self.isConnected || !self.needsCustomAdd()) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        self.addToCart(btn);
      };
      document.addEventListener('click', this.clickHandler, true);
      if (this.form) {
        this.submitHandler = function (e) {
          if (!self.needsCustomAdd()) return;
          e.preventDefault();
          e.stopImmediatePropagation();
          self.addToCart(self.form.querySelector('[type="submit"]'));
        };
        this.form.addEventListener('submit', this.submitHandler, true);
      }
    }

    buildItems() {
      var d = this.data;
      var t = this.tier();
      var props = {};
      if (this.form) {
        new FormData(this.form).forEach(function (val, key) {
          var m = key.match(/^properties\[(.+)\]$/);
          if (m && val !== '') props[m[1]] = val;
        });
      }
      var bundleProps = Object.assign({}, props);
      bundleProps['_sv_bundle'] = t.label || String(t.qty);
      var counts = {};
      var order = [];
      this.unitVariants.forEach(function (v) {
        if (!counts[v.id]) { counts[v.id] = 0; order.push(v.id); }
        counts[v.id] += 1;
      });
      var items = order.map(function (id) {
        return { id: id, quantity: counts[id], properties: bundleProps };
      });
      if (d.eligible && t.gift_mode === 'product' && t.gift && t.gift_qty > 0) {
        items.push({ id: t.gift.id, quantity: t.gift_qty, properties: { _sv_bundle_gift: t.label || String(t.qty) } });
      }
      var tierEl = this.tiers[this.tierIndex];
      if (d.eligible) {
        (t.perks || []).forEach(function (p) {
          var id = p.id;
          if (p.mode === 'choose' && tierEl) {
            var sel = tierEl.querySelector('[data-sv-perk="' + p.slot + '"] select[data-sv-perk-variant]');
            if (sel && sel.value) id = parseInt(sel.value, 10);
          }
          items.push({ id: id, quantity: p.qty || 1, properties: { _sv_bundle_gift: t.label || String(t.qty) } });
        });
      }
      this.selectedAddons().forEach(function (a) {
        items.push({ id: a.id, quantity: 1, properties: { _sv_addon: '1' } });
      });
      return items;
    }

    showError(msg) {
      if (!this.errorEl) return;
      this.errorEl.textContent = msg || '';
      this.errorEl.hidden = !msg;
    }

    addToCart(btn) {
      var self = this;
      if (this.busy) return;
      this.busy = true;
      this.showError('');
      if (btn) {
        btn.setAttribute('aria-disabled', 'true');
        btn.classList.add('loading');
      }
      var drawer = document.querySelector('cart-drawer');
      var sections = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : [];
      var body = { items: this.buildItems() };
      if (sections.length) {
        body.sections = sections.join(',');
        body.sections_url = window.location.pathname;
      }
      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (res) {
          if (!res.ok || res.json.status) {
            self.showError(res.json.description || res.json.message || self.data.strings.error);
            return;
          }
          document.dispatchEvent(new CustomEvent('sv:bundle-added', { detail: { items: body.items, response: res.json } }));
          if (drawer && res.json.sections && typeof drawer.renderContents === 'function') {
            var first = res.json.items && res.json.items[0];
            try {
              if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
              drawer.renderContents({ id: first ? first.id : null, sections: res.json.sections });
              if (drawer.classList && !drawer.classList.contains('active') && typeof drawer.open === 'function') {
                setTimeout(function () { if (!drawer.classList.contains('active')) drawer.open(btn); }, 50);
              }
            } catch (e) {
              window.location.href = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
            }
          } else {
            window.location.href = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
          }
        })
        .catch(function () {
          self.showError(self.data.strings.error);
        })
        .finally(function () {
          self.busy = false;
          if (btn) {
            btn.removeAttribute('aria-disabled');
            btn.classList.remove('loading');
          }
        });
    }
  }

  window.customElements.define('sv-bundle', SvBundle);
})();
